import { T } from "../constants";

export default function PropPill({ label }) {
  return (
    <span style={{
      fontSize: "0.72rem", padding: "2px 8px",
      border: `0.5px solid ${T.linen3}`,
      borderRadius: "2px", color: "#8a5040",
      background: "rgba(255,255,255,0.6)",
      whiteSpace: "nowrap",
    }}>
      {label}
    </span>
  );
}
